var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBetaBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.201 5.126h1.12c.813 0 1.491.161 2.035.483.548.322.96.745 1.236 1.27.276.521.412 1.083.408 1.684.004.678-.155 1.282-.477 1.81a3.428 3.428 0 0 1-1.299 1.242c-.544.299-1.157.448-1.839.448-.406 0-.806-.063-1.201-.19a2.663 2.663 0 0 1-1.075-.7l-.086.034V8.402c.004.341.084.653.241.937a1.8 1.8 0 0 0 .673.684c.295.168.647.253 1.057.253.406 0 .757-.085 1.052-.253.299-.169.53-.393.695-.673a1.75 1.75 0 0 0 .242-.925 1.705 1.705 0 0 0-.247-.937 1.812 1.812 0 0 0-.684-.643 1.97 1.97 0 0 0-.972-.236h-.879V5.126zM3.793 0c.525 0 1.012.079 1.46.236.452.157.845.377 1.178.66.337.28.598.612.782.995.187.38.281.795.281 1.247a3.225 3.225 0 0 1-.396 1.552 3.272 3.272 0 0 1-1.179 1.247c-.517.325-1.155.488-1.913.488H3.2v-1.42h.563c.403 0 .728-.08.977-.24.253-.165.439-.37.558-.616.119-.249.176-.5.172-.752a1.429 1.429 0 0 0-.465-1.11c-.31-.295-.715-.442-1.213-.442-.33 0-.628.069-.896.207a1.58 1.58 0 0 0-.633.597 1.765 1.765 0 0 0-.241.92V15.24H0V3.465c0-.693.167-1.3.5-1.821A3.421 3.421 0 0 1 1.862.43C2.437.144 3.08 0 3.793 0z",
    fill: "#500D76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetaBrand);
export default __webpack_public_path__ + "static/media/betaBrand.d1165a62013d79560ed1b9d8b2156515.svg";
export { ForwardRef as ReactComponent };